export const SLL_SET_MODE = 'SLL_SET_MODE';

export const SLL_SET_BOXES = 'SLL_SET_BOXES';
export const SLL_CLEAR_BOXES = 'SLL_CLEAR_BOXES';

export const SLL_CLEAR_STACKLL = 'SLL_CLEAR_STACKLL';
export const SLL_CLEAR_INPUT = "SLL_CLEAR_INPUT"

export const SLL_ON_NODE_CHANGE = "SLL_ON_NODE_CHANGE";
export const SLL_CLEAR_ON_INC = "SLL_CLEAR_ON_INC";
export const SLL_PUSH_NODE = 'SLL_PUSH_NODE';
export const SLL_POP_NODE = 'SLL_POP_NODE';
export const SLL_CLEAR_ON_DEC = 'SLL_CLEAR_ON_DEC'
export const SLL_POP = 'SLL_POP'
